export default {
  /**
   * Path to routes request to the PHP router (web.php)
   *
   * @deprecated
   * The PHP stack is being divested. This should no longer be used.
   *
   * @returns hostname/portal -> e.g. http://whitepaperprod.advrw.com/portal
   */
  internal(): string {
    return `${window.location.origin}/${process.env.VUE_APP_BASE_FOLDER}`;
  },
  /**
   * Path to route all requests to the PHP Proxy Controller.
   *
   * @deprecated
   * The PHP proxy controller is being divested. This should no longer be used.
   *
   * @returns hostname/ms -> e.g. http://whitepaperprod.advrw.com/portal/ms
   */
  microservice(): string {
    const internalBase = this.internal();

    return `${internalBase}/ms`;
  },
};
